const messages_en = {
  //example
  'example.welcome': 'Welcome {userName}',
  'example.pages': 'Pages {pageText}'
}

export default messages_en;